<template>
  <div>
    <DataTable :value="leaveRequestList" :paginator="true" :rows="8" :filters="filters">
      <Column header="S.N" field=""/>
      <Column header="Name" :sortable="true" field="employeeName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['employeeName']" />
        </template>
      </Column>
      <Column header="Date From" :sortable="true" field="fromDate"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['fromDate']" />
        </template>
      </Column>
      <Column header="Date To" :sortable="true" field="toDate"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['toDate']" />
        </template>
      </Column>
      <Column header="Alternative Employee" :sortable="true" field="alternateEmployeeName"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['alternateEmployeeName']" />
        </template>
      </Column>
      <Column header="Leave Type" :sortable="true" field="absenceType"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['absenceType']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editLeaveRequest(slotProps.data)" />
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteLeaveRequest"/>
  </div>
</template>
<script>
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
export default {
  name: 'leaveEmployeeRequestList',
  data() {
    return {
      editing: false,
      employeeId: null,
      deleteDialog: false,
      filters: {}
    }
  },
  computed: {
    leaveRequestList() {
      return this.$store.state.hr.leaveRequestList
    }
  },
  mounted() {
    this.findLeaveRequestList()
  },
  methods: {
    async findLeaveRequestList() {
      await this.$store.dispatch('loadLeaveRequestList')
    },
    editLeaveRequest(data) {
      this.$emit('edit-employee', data)
    },
    async deleteLeaveRequest(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let employee = {
        id: this.employeeId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteLeaveRequest', employee)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Employee ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    openDeleteDialog(id) {
      this.employeeId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog
  }
}
</script>



// WEBPACK FOOTER //
// leaveReports.vue?662d2084